import * as React from 'react';

import { SupplierFaqScreen } from '@/routes/supplier/faq/faq-screen';

// =============================================================================
// faq-route.tsx — Adaptateur routeur de la page « FAQ » FOURNISSEUR (GATE_HUMAN 2026-09-11).
// =============================================================================
// La FAQ est un contenu FIXE plateforme (faq-content.ts) : aucune donnée serveur, aucun état d'URL à
// porter. L'adaptateur reste néanmoins présent pour l'homogénéité du routage (écran testable hors routeur).

export function SupplierFaqRoute(): React.JSX.Element {
  return <SupplierFaqScreen />;
}
